<template>
    <div class="page gc">
        <div class="container g9">
            <div class="inner">
                <h1>Forgot your password?</h1>
                <h3>Enter your e-mail address and we'll get you back on track.</h3>

                <form v-on:submit="onSubmit" action="#" method="post" id="form">
                    <div class="input" ref="email" type="email" v-bind:class="{ 'error': emailError }">
                        <label>
                            <span>E-mail address</span>
                            <input type="email" placeholder="E-mail" v-model="email" tabindex="1"/>
                        </label>
                    </div>

                    <button v-bind:class="{ 'loading': isLoading }">Request reset link</button>
                </form>
            </div>
            <p>Sply Tech ApS - All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
    import API from "../../Api"

    export default {
        data: () => ({
            email: null,
            emailError: false,
            isLoading: false
        }),
        methods: {
            onSubmit (e) {
                e.preventDefault();

                this.isLoading = true;

                this.emailError = this.email == null || this.email == "";

                if(this.emailError)
                {
                    this.isLoading = false;
                    return false;
                }

                API.post("member/resetpassword", {
                    email: this.email
                }).then((res) => {
                    this.isLoading = false;

                    // Make reload of page after login
                    window.location = "/login";
                }).catch((res) => {
                    this.isLoading = false;
                    console.log(res)
                })
            }
        }
    }
</script>
